import { ERROR_STRING } from '@/config/constants';
import { ContractBusinessType, ContractSubtype } from '@/gql/graphql';

export function formatContractBusinessType(type: string | null | undefined): string {
  if (!type) {
    return '';
  }

  switch (type) {
    case ContractSubtype.Sale:
    case ContractSubtype.Custom:
    case ContractBusinessType.B2b:
      return 'B2B';

    case ContractSubtype.Info:
    case ContractBusinessType.B2c:
      return 'B2C';
  }

  console.warn(`Unknown contract business type: "${type}"`);
  return ERROR_STRING;
}
